// AntAllergenListBox.tsx
import React from "react";
import { ListBox } from "primereact/listbox";
import { AllergenModel } from "../../../services/allergens/models/allergen.model";
import "./ant-allergen-listbox.css";

interface Props {
  allergenList: AllergenModel[];
  value?: number[];
  onChange?: (value: number[]) => void;
}

const AntAllergenListBox: React.FC<Props> = ({
  allergenList,
  value = [],
  onChange,
}) => {
  const options = allergenList.map((a) => ({
    label: `${a.group ?? ""}${a.examples ? ` — ${a.examples}` : ""}`,
    value: a.id,
  }));

  return (
    <div className="allergen-listbox-wrap">
      <ListBox
        multiple
        filter
        filterPlaceholder="Alerjen ara..."
        value={value}
        onChange={(e) => onChange?.(e.value ?? [])}
        options={options}
        optionLabel="label"
        optionValue="value"
        listStyle={{ maxHeight: "220px" }}
        itemTemplate={(option) => (
          <div className="allergen-listbox-item">
            <span className="allergen-listbox-dot" />
            <span className="allergen-listbox-label">{option.label}</span>
          </div>
        )}
      />
      {value.length > 0 && (
        <div className="allergen-selected-tags">
          {allergenList
            .filter((a) => value.includes(a.id))
            .map((a) => (
              <span key={a.id} className="allergen-tag">
                <span className="allergen-tag-dot" />
                {a.group}
                <button
                  type="button"
                  className="allergen-tag-remove"
                  onClick={() => onChange?.(value.filter((id) => id !== a.id))}
                >
                  ×
                </button>
              </span>
            ))}
        </div>
      )}
    </div>
  );
};

export default AntAllergenListBox;
